export default __webpack_public_path__ + "static/media/download2.28c85f93.svg";